/**
 * Boot Screen Config Schemas
 *
 * Per-school configurable boot messages shown inside <JourneyLoader> while
 * the mobile app hydrates its app-config. Stored as a row in the existing
 * `SystemConfiguration` table with category=APPEARANCE, key=BOOT_SCREEN.
 */

import { z } from 'zod'

export const BOOT_SCREEN_MESSAGE_MAX_LENGTH = 160
export const BOOT_SCREEN_MESSAGES_MAX = 20

const URL_REJECT_REGEX = /(https?|ftp):\/\//i

export const BootScreenMessageSchema = z.object({
  id: z.string().min(1),
  text: z
    .string()
    .trim()
    .min(1, 'Message cannot be empty')
    .max(BOOT_SCREEN_MESSAGE_MAX_LENGTH, `Message must be ≤${BOOT_SCREEN_MESSAGE_MAX_LENGTH} characters`)
    .refine(value => !URL_REJECT_REGEX.test(value), {
      message: 'URLs are not allowed in boot messages'
    })
})

export type BootScreenMessage = z.infer<typeof BootScreenMessageSchema>

export const BootScreenConfigSchema = z.object({
  enabled: z.boolean(),
  messages: z.array(BootScreenMessageSchema).max(BOOT_SCREEN_MESSAGES_MAX)
})

export type BootScreenConfig = z.infer<typeof BootScreenConfigSchema>
